<template>
  <div class="report-check">
    <div class="data-content">
      <div class="table-head">
        <div class="table-title">
          <span style="font-weight: bold">用户订单信息列表</span>
        </div>
        <div>
            <Input
                v-model="filterData.invite_code"
                maxlength="6"
                placeholder="用户身份ID"
                clearable
                style="min-width: 80px; width:150px; margin-right: 10px;"/>
            <Button @click="getData()">搜索</Button>
        </div>
      </div>
      <div class="title-info">用户信息</div>
      <div style="width: 100%; display: flex;">
         
          <div class="avatar">
              <Poptip trigger="hover" :transfer="true" title="图片详情">
                    <div class="info-pop" slot="content">
                        <img :src="user.avatar" class="img-avatar-preview">
                    </div>
                    <img :src="user.avatar" class="img-avatar">
              </Poptip>
          </div>
          <div class="report-content">
              <div class="user-nickname">{{ user.nickname }}</div>
              <div class="user-created-at">创建时间：{{ user.created_at }}</div>
              <div class="user-invite-code">身份ID：{{ user.invite_code }}</div>
              <div class="report-bottom">
                   <div class="report-desc">区号：{{ user.phone_area ? '+'+user.phone_area : '暂无' }} ，手机号：{{ user.phone_number ? user.phone_number : '暂无' }}</div>
                   <div class="report-desc" v-if="user.wx_openid">微信-OpenId：{{ user.wx_openid ? user.wx_openid : '暂无' }}</div>
                   <div class="report-desc" v-if="user.qq_openid">QQ-OpenId： {{user.qq_openid ? user.qq_openid : '暂无'}}</div>
                   <div class="report-desc" v-if="user.apple_openid">Apple-OpenId： {{user.apple_openid ? user.apple_openid : '暂无'}}</div>
                   <div class="report-desc">阶段： {{user.stage ? user.stage : '自由中'}}</div>
                   <div class="report-desc">任意门： {{user.membership_level == 1 ? '是' : '否'}}</div>
                   <div class="report-desc">账号状态： <span :style="user.app_status_color">{{user.app_status}}</span></div>
                </div>
          </div>
      </div>
      <div style="margin-left: 4rem;margin-bottom: 1rem;">
          <Input
              v-model="filterData.jewelCount"
              placeholder="请输入Co钻的数量"
              clearable
              style="min-width: 80px; width:150px; margin-right: 10px;"/>
          <Button @click="toRemoveJewelCount()">扣除Co钻</Button>
      </div>
      <div class="title-info">钻使用分布（订单总金额：{{totalPrice}}元 , 钻剩余数量：{{totalBalanceAmountPrice}}个）</div>
      <Table :columns="dist_columns" :data="changeDistDataList" @on-selection-change="selected">
        <template slot-scope="{ row, index }" slot="deal_type">
          <span>{{ row.deal_type }}</span>
        </template>
      
        <template slot-scope="{ row, index }" slot="deal_title">
          <span>{{ row.deal_title }}</span>
        </template>
      
        <template slot-scope="{ row, index }" slot="amount">
         <span>{{ row.amount }}</span>
        </template>
      
        <template slot-scope="{ row, index }" slot="use_type_info">
          <span>{{ row.use_type_info }}</span>
        </template>
      </Table>
      <!-- <div class="title-info">钻订单列表（充值总金额：{{totalPrice}}元）</div> -->
      <Table :columns="order_columns" :data="changeOrderDataList" @on-selection-change="selected">
        <template slot-scope="{ row, index }" slot="id">
          <span>{{ row.id }}</span>
        </template>
      
        <template slot-scope="{ row, index }" slot="order_no">
          <span>{{ row.order_no }}</span>
        </template>
      
        <template slot-scope="{ row, index }" slot="pay_time">
         <span>{{ row.pay_time }}</span>
        </template>
      
        <template slot-scope="{ row, index }" slot="pay_type_info">
          <span>{{ row.pay_type_info }}</span>
        </template>
      
        <template slot-scope="{ row, index }" slot="pay_price">
          <span>{{ row.pay_price }}</span>
        </template>
      </Table>
      <div class="title-info">赞助记录（最近7天）</div>
      <Table :columns="give_columns" :data="giveDataList" @on-selection-change="selected">

        <template slot-scope="{ row, index }" slot="room_id">
          <span>{{ row.room_id }}</span>
        </template>
              
        <template slot-scope="{ row, index }" slot="deal_title">
          <span>{{ row.deal_title }}</span>
        </template>
      
        <template slot-scope="{ row, index }" slot="amount">
         <span>{{ row.amount }}</span>
        </template>
     
        <template slot-scope="{ row, index }" slot="user_id">
          <span>{{ row.user_id }}</span>
        </template>
        
        <template slot-scope="{ row, index }" slot="invite_code">
          <span>{{ row.invite_code }}</span>
        </template>
        
        <template slot-scope="{ row, index }" slot="nickname">
          <span>{{ row.nickname }}</span>
        </template>
      </Table>
      <div class="title-info">钻消费记录（最近100条）</div>
      <Table :columns="columns" :data="changeDataList" @on-selection-change="selected" >
        <template slot-scope="{ row, index }" slot="id">
          <span>{{ row.id }}</span>
        </template>

        <template slot-scope="{ row, index }" slot="created_at">
          <span>{{ row.created_at }}</span>
        </template>

        <template slot-scope="{ row, index }" slot="amount">
         <span>{{ row.amount }}</span>
        </template>

        <template slot-scope="{ row, index }" slot="balance_amount">
          <span>{{ row.balance_amount }}</span>
        </template>

        <template slot-scope="{ row, index }" slot="deal_type">
          <span>{{ row.deal_type }}</span>
        </template>

        <template slot-scope="{ row, index }" slot="deal_title">
          <span>{{ row.deal_title }}</span>
        </template>

        <template slot-scope="{ row, index }" slot="source">
          <span>{{ row.source }}</span>
        </template>
      </Table>
    </div>
  </div>
</template>

<script>
import apis from "../../http/api";
import commonApi from "../../utils/commonapi";

export default {
  name: "ReportCheck",
  components: {},
  watch: {
  },
  data() {
    return {
      filterData: {
        invite_code:null,
        jewelCount:null,
        canjewelCount:false,
      },
      selectedItem: [],
      selectedId: [],
      dataList: [],
      user:{'avatar':"https://image.co-study.com.cn/app/image/avatar/webco.png",'nickname':'Co用户昵称','invite_code':'0000'},
      avatar: null,  // 被举报人头像
      orderDataList: [],
      distDataList: [],
      giveDataList: [],
      totalPrice: '0',
      totalBalanceAmountPrice: '0',
      columns: [
        {
          title: '钻消费id',
          slot: 'id',
          align: 'center'
        },
        {
          title: '钻使用时间',
          slot: 'created_at',
          align: 'center'
        },
        {
          title: '钻个数',
          slot: 'amount',
          align: 'center'
        },
        {
          title: '钻剩余数量',
          slot: 'balance_amount',
          align: 'center'
        },
        {
          title: '消费类型',
          slot: 'deal_type',
          align: 'center'
        },
        {
          title: '消费详情',
          slot: 'deal_title',
          align: 'center'
        },
        {
          title: '额外信息',
          slot: 'source',
          align: 'center'
        }
      ],
      order_columns: [
        {
          title: 'ID',
          slot: 'id',
          align: 'center'
        },
        {
          title: '订单号',
          slot: 'order_no',
          align: 'center'
        },
        {
          title: '支付时间',
          slot: 'pay_time',
          align: 'center'
        },
        {
          title: '支付类型',
          slot: 'pay_type_info',
          align: 'center'
        },
        {
          title: '支付金额',
          slot: 'pay_price',
          align: 'center'
        }
      ],
      dist_columns: [
        {
          title: '分布类型ID',
          slot: 'deal_type',
          align: 'center'
        },
        {
          title: '分布类型名称',
          slot: 'deal_title',
          align: 'center'
        },
        {
          title: '消费/充值钻个数',
          slot: 'amount',
          align: 'center'
        },
        {
          title: '是否可退',
          slot: 'use_type_info',
          align: 'center'
        }
      ],
      give_columns: [
        {
          title: '被赞助空间ID',
          slot: 'room_id',
          align: 'center'
        },          
        {
          title: '被赞助空间名称',
          slot: 'deal_title',
          align: 'center'
        },
        {
          title: '赞助总钻数(7日内)',
          slot: 'amount',
          align: 'center'
        },
        {
          title: '被赞助的用户ID',
          slot: 'user_id',
          align: 'center'
        },
        {
          title: '被赞助的用户邀请码',
          slot: 'invite_code',
          align: 'center'
        },
        {
          title: '被赞助的用户昵称',
          slot: 'nickname',
          align: 'center'
        }
      ],
    }
  },
  created() {
      // 测试代码
      // this.filterData.invite_code = "Vk0p"
      // this.getData()
  },
  methods: {
    getData() {
      if(this.filterData.invite_code == undefined){
          alert('请输入用户身份ID')
          return 
      }
      let params = {
        invite_code: this.filterData.invite_code
      };
      apis.tool_user_order_info(params).then(res => {
        const { data, errCode, msg } = res;
        if (errCode === 0) {
          this.canjewelCount = true
          var list = data.use_jewel_records
          var user =data.user_info
          var avatar = user.avatar
          if(avatar == undefined || avatar == ""){
              avatar = "webco.png"
          }
          if(avatar.startsWith("http")){
              
          }else{
              user['avatar'] = "https://image.co-study.com.cn/app/image/avatar/"+ avatar
          }
          // 0为正常，-1为封禁, -2是注销
          var status = '正常'
          var color = {color:"#000000"}
          switch(user.active){
              case -1:
                status = '封禁'
                color = {color:'red'}
                break
              case -2:
                status = '注销'
                color = {color:'gray'}
                break
              case 0:
                status = '正常'
                color = {color:'green'}
                break
              default:
                status = '未知'
                color = {color:"#000000"}
                break
          }
          user['app_status'] = status
          user['app_status_color'] = color
          this.user = user
          this.dataList =list;
          this.orderDataList = data.orders
          this.distDataList = data.use_jewel_distribution
          this.giveDataList = data.give_jewel_distribution
          this.totalPrice = data.order_sum_price
          if(this.dataList.length >0){
             this.totalBalanceAmountPrice = this.dataList[0].balance_amount
          }else{
             this.totalBalanceAmountPrice = "0"
          }
        }else{
          alert(msg)
        }
      }).catch(err => {
        alert("接口异常")
      })
    },
    toRemoveJewelCount() {
      if(this.filterData.invite_code == undefined){
          this.$Message.error('请输入用户身份ID'); 
          return 
      }
      if(this.filterData.jewelCount == undefined){
          this.$Message.error('请输入要扣除的Co钻数量！'); 
          return 
      }
      var numReg = /^[0-9]*$/
      var numRe = new RegExp(numReg)
      if(!numRe.test(this.filterData.jewelCount)){
        this.$Message.error('请输入数字！'); 
        return
      }
      let params = {
        invite_code: this.filterData.invite_code,
        jewel: this.filterData.jewelCount
      };
      if(this.canjewelCount){
          this.canjewelCount = false
          apis.tool_user_income_user_jewel_withhold(params).then(res => {
            const { data, errCode, msg } = res;
            if (errCode === 0) {
                commonApi.recordFromOperationToolRemoveJewelCount(0, this.filterData.jewelCount,this.filterData.invite_code)
                this.filterData.jewelCount = null
                this.$Message.success('Co钻扣除成功！'); 
                this.getData()
            }else{
              alert(msg)
              this.canjewelCount = true
            }
          }).catch(err => {
            alert("接口异常")
            this.canjewelCount = true
          })
      }
     
    },
    selected(selecttion) {
      this.selectedId = [];
      this.selectedItem = selecttion;
      selecttion.forEach(item => {
        this.selectedId.push(item.id)
      })
      console.log(this.selectedId)
    },
  },
  computed: {
    changeDataList() {
        return this.dataList.map(item => {
          return item
        })
    },
    changeOrderDataList() {
        return this.orderDataList.map(item => {
            // 创建 item 的副本，避免直接修改原始数据
            const newItem = Object.assign({}, item);
            //1为苹果，2支付宝，3微信, 4公众号 
            if(newItem.pay_type == 1){
                newItem.pay_type_info = "苹果"
            }else if(newItem.pay_type == 2){
                newItem.pay_type_info = "支付宝"
            }else if(newItem.pay_type == 3){
                newItem.pay_type_info = "微信"
            }else if(newItem.pay_type == 4){
                newItem.pay_type_info = "公众号"
            }else{
                newItem.pay_type_info = "未知"
            }
          return newItem
        })
    },
    changeDistDataList() {
        return this.distDataList.map(item => {
            // 创建 item 的副本，避免直接修改原始数据
            const newItem = Object.assign({}, item);
            if(newItem.use_type == 1){
               newItem.use_type_info = "不可退"
            }else if(newItem.use_type == 0){
               newItem.use_type_info = "可退"
            }else{
               newItem.use_type_info = "未知"
            }
          return newItem
        })
    }
  },
  filters: {
  }
}
</script>

<style scoped>
.report-check {
  margin: 10px;
}

.clickable-span {
  color: #1890ff;
  text-decoration: underline;
  cursor: pointer;
}

.text-center {
  text-align: center;
}

.table-head {
  display: flex;
  justify-content: space-between;
  padding-bottom: 5px;
}

.table-title {
  align-self: center;
}

.modal1-div {
  margin-bottom: 10px;
}

.info-pop {
  white-space: pre-wrap;
}

.avatar{
    float: left;
    width: 50px;
    margin-top: 20px;
}
.img-avatar{
    width: 50px;
    height: 50px;
    border-radius: 50%;
}
.img-avatar-preview{
    width: 400px;
    height: 400px;
}
.report-content{
    float: left;
    width: 600px;
    margin-top: 20px;
    margin-bottom: 20px;
    margin-left: 20px;
}
.user-nickname{
    font-weight: bold;
    float: left;
    font-size: 16px;
    width: 300px;
    color: #000000;
}
.user-created-at{
    font-weight: normal;
    background-color: #0D7EDA;
    font-size: 16px;
    float: right;
    color: #cccccc;
}
.user-invite-code{
    font-weight: bold;
    float: left;
    font-size: 14px;
    margin-top: 8px;
    width: 300px;
    color: #cccccc;
}
.user-report-type{
    font-weight: normal;
    font-size: 14px;
     margin-top: 8px;
    float: right;
    color: #cccccc;
}
.report-bottom{
    float: left;
    margin-top: 8px;
    width: 500px;
}
.report-desc{
    font-weight: normal;
    font-size: 16px;
    color: #000000;
}
.report-img-container{
    margin-top: 20px;
}
.report-img{
    margin-right: 20px;
}
.report-image{
   width: 80px;
   height: 80px; 
}
.report-type{
    font-weight: bold;
    font-size: 16px;
    margin-top: 10px;
    margin-bottom: 10px;
    color: #000000;
}
.title-info{
    font-weight: bold;
    font-size: 16px;
    margin-top: 10px;
    margin-bottom: 10px;
    color: #000000;
}
</style>
